import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const listFulfillmentRulesPageAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.deliveryOrchestration],
    permissions: [Permission.View],
    restrictedBannersAllowed: true,
  },
  {
    warehouseFeatureToggles: [FeatureToggle.deliveryOrchestration],
    permissions: [Permission.View],
    restrictedBannersAllowed: true,
  },
]
